<!-- 首頁 home -->
@if (showAnimation) {
<div class="home-container home-landing-content">
  <div class="home-landing-text">
    <div class="home-landing-text-first">
      <p>5,000+</p>
      <p>智慧演算、專業分析</p>
    </div>
    <div class="home-landing-text-last">
      <p>個人化精準數據</p>
      <p>每個環節都為您量身設計</p>
    </div>
  </div>

  <img priority class="home-landing-img" ngSrc="/assets/img/img-landing.png" alt="Loading Animation" height="1506"
    width="2460" />

  <img priority class="home-landing-img-m" ngSrc="/assets/img/img-landing-m.jpg" alt="Loading Animation" height="1624"
    width="750" />
</div>
} @else {
@if (isZhTw) {
<div class="page">
  <!-- ===== HERO ===== -->
  <section class="section-hero">
    <div class="container">
      <div class="hero-content">
        <div class="hero-content__left">
          <div class="hero-title">
            <h1>每個人的生活不同<br />檢查當然也該不同</h1>
            <div class="hero-subtitle">
              <img class="mobile-img-title" src="assets/img/web_logo_L.svg" alt="衡好選"
                style="margin-right: 10px;" />
              <img class="mobile-img" src="assets/img/web_logo_subtitle_L.svg" alt="智能健檢" />
            </div>
          </div>

          <div class="selection-card">
            <div class="action-board__group">
              <div class="action-board__header" style="gap: 0px;">
                <span class="icon">
                  <img src="assets/img/icon-building.svg" alt="icon" class="icon-img" />
                </span>
                <span style="color:#1bbf9c">企業員工．眷屬</span>的健檢方案
              </div>

              <div class="action-board">
                <div class="action-board__input-wrap">
                  <input type="text" placeholder="請輸入企業代碼" [class.input-error]="hasError"
                    [formControl]="enterpriseCodeControl" (keydown.enter)="handleEnterpriseClick()" maxlength="10"
                    (input)="onInputChange($event)" />
                  <button class="btn-start" [disabled]="isButtonDisabled" (click)="handleEnterpriseClick()">
                    開始預約
                  </button>
                </div>
              </div>
            </div>

            <div class="action-board__group">
              <div class="action-board__header" style="gap: 0px;">
                <span class="icon">
                  <img src="assets/img/icon-family-users.svg" alt="icon" class="icon-img" />
                </span>
                <span style="color:#1bbf9c">個人專屬</span>的健檢方案
              </div>

              <div class="action-board">
                <div class="action-board__btns">
                  <button class="btn-outline" (click)="handlePersonalClick()">
                    曾經來過，直接預約 <span>→</span>
                  </button>
                  <button class="btn-outline" (click)="handleQuickReserveClick()">
                    第一次來，了解方案 <span>→</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="hero-content__right">
          <div class="buddy-grid" #buddyGrid>
            @for (buddy of buddyIcons; track $index) {
            <div class="buddy-node" [class.buddy-node--active]="hoveredBuddy() === $index"
              (mouseenter)="onBuddyMouseEnter($index)" (mouseleave)="startBuddyTimer()">
              <div class="buddy-node__icon">
                <img [src]="getIconPath($index, buddy.id)" [alt]="buddy.title" />
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ===== SECTION 2: 日常習慣 ===== -->
  <section class="section-habit ">
    <div class="container">
      <div class="section__topic" style="text-align: center;margin-bottom: 40px;">
        <h2>不同生活背景的人，關注的檢查面向也不同</h2>
        <p>以下有您的影子嗎？沒有的話，3 分鐘試算找出專屬自己檢查</p>
      </div>

      <mat-tab-group class="habit-tabs" [mat-stretch-tabs]="false" [disablePagination]="true" dynamicHeight
        animationDuration="500ms" (selectedIndexChange)="activeBuddyTab.set($event)">
        @for (tab of buddyTabs; track tab.label) {
        <mat-tab [label]="tab.label"></mat-tab>
        }
      </mat-tab-group>

      <section class="section-habit" style="padding-top: 0px;">
        <div class="container">
          <div class="habit-content">
            @if (buddyCards[activeBuddyTab()]; as currentData) {
            <div class="card-stack">
              <div class="card-decoration card-decoration--bottom"></div>
              <div class="card-decoration card-decoration--middle"></div>

              @if (activeBuddyTab() === 4) {
              <mat-card class="habit-card-main cta-start-card">
                <mat-card-content class="cta-start-layout">
                  <div class="cta-visual">
                    <img src="assets/img/img - buddy.svg" alt="尋找屬於您的樣貌" />
                  </div>
                  <div class="cta-info">
                    <h2 class="cta-title">尋找屬於您的樣貌</h2>
                    <p class="cta-subtitle">3 分鐘試算找出您的專屬項目</p>
                  </div>
                  <div class="cta-action">
                    <button class="btn-primary-teal btn-size-l" (click)="openCalculationDialog()">
                      開始試算
                    </button>
                  </div>
                </mat-card-content>
              </mat-card>
              } @else {
              <mat-card class="habit-card-main">
                <mat-card-content class="habit-card-layout">
                  <div class="habit-card__visual">
                    <img [src]="currentData.image" alt="Visual" />
                  </div>

                  <div class="habit-card__info">
                    <div class="habit-card_sense">
                      <span class="recommend-title"
                        style="font-weight: 800;margin-right: 10px;position: relative;top:10px">
                        相關背景
                      </span>
                      <div class="habit-card__badge">
                        @for (item of currentData.reason; track item) {
                        <span class="chip">{{ item }}</span>
                        }
                      </div>
                    </div>

                    <div class="habit-card__recommend">
                      <h3 class="recommend-title">最常選擇</h3>
                      <div class="chip-group">
                        @for (item of currentData.recommended; track item) {
                        <span class="chip">{{ item }}</span>
                        }
                      </div>
                    </div>

                    <div class="habit-card__note">
                      <p>{{ currentData.note }}</p>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
              }
            </div>
            }
          </div>
        </div>

        <p class="recommend-notice">
          此為預覽參考，實際項目我們以您填寫完整個人資料為準
        </p>
      </section>

      <!-- ===== SECTION 3: 百萬客戶 ===== -->
      <section  class="section-team">
        <div class="container">
          <div class="section__topic" style="text-align: center;">
            <h2>過去 15 年、百萬客戶，看見您可能遺漏的健康風險</h2>
            <p>根據您的生活習慣、身體背景與家族史，分析出您真正需要優先關注的項目</p>
          </div>
          <div class="team-main-wrapper">
            <div class="doctor-visual">
              <picture>
                <source media="(max-width: 768px)" srcset="assets/img/doctor-chen-mobile.svg" />
                <img src="assets/img/doctor-chen.svg" alt="陳皇光 院長" class="img-doctor" />
              </picture>
            </div>

            <div class="team-roles-box">
              <picture>
                <source media="(max-width: 768px)" srcset="assets/img/itemGroup-mobile.svg" />
                <img src="assets/img/itemGroup.svg" alt="專業醫護團隊" class="team-roles-img" />
              </picture>
            </div>
          </div>
        </div>
      </section>

      <section class="section-logic-transition">
        <div class="container">
          <div class="logic-flex-wrapper">
            <div class="logic-column left">
              <h2 class="logic-title">因為我們懂您的不一樣</h2>
              <p class="logic-desc">
                我們從<span class="highlight">三億筆臨床數據</span>裡，透過相似性與關聯性分析，並搭配您<span
                  class="highlight">每一次檢查累積</span>下來的數據變化，整理出最需要關注的地方。
              </p>
            </div>

            <div class="logic-column center">
              <div class="balloon-visual">
                <img src="assets/img/ballon.svg" alt="分析維度" class="balloon-img" />
              </div>
            </div>

            <div class="logic-column right">
              <h2 class="logic-title">所以，我們知道</h2>
              <h3 class="logic-result">您需要檢查什麼</h3>
            </div>
          </div>
        </div>
      </section>

      <!-- ===== SECTION 4: 迷思翻牌 ===== -->
      <section class="section section--green">
        <div class="section__inner section__inner--myth">
          <div class="section__topic">
            <h2>關於健檢，幾個<span>值得了解的觀念</span></h2>
            <p>翻開卡片，滿足您對健檢的好奇</p>
          </div>

          <div class="myth-carousel">
            <button class="myth-carousel__btn myth-carousel__btn--prev" (click)="prevMyth()">‹</button>

            <div class="myth-cards" #mythCards (wheel)="onMythWheel($event)" (mousedown)="onMouseDown($event)"
              (mousemove)="onMouseMove($event)" (mouseup)="onMouseUpOrLeave()" (mouseleave)="onMouseUpOrLeave()">
              @for (myth of myths; track myth.num; let i = $index) {
              <div class="myth-card" [class.myth-card--flipped]="isFlipped(i)" (click)="toggleFlip(i)">
                <div class="myth-card__inner">
                  <div class="myth-card__front">
                    <div class="myth-card__bar">
                      <span class="myth-card__icon">⇄</span>
                      <span class="myth-card__num">迷思 {{ myth.num }}</span>
                    </div>
                    <div class="myth-card__question">{{ myth.question }}</div>
                    <button class="myth-card__btn">翻轉看解答</button>
                  </div>

                  <div class="myth-card__back">
                    <div class="myth-card__bar">
                      <span class="myth-card__icon myth-card__icon--light">⇄</span>
                      <span class="myth-card__num myth-card__num--light">迷思 {{ myth.num }}</span>
                    </div>
                    <div class="myth-card__answer">{{ myth.answer }}</div>
                    <button class="myth-card__btn myth-card__btn--back">收起</button>
                  </div>
                </div>
              </div>
              }
            </div>

            <button class="myth-carousel__btn myth-carousel__btn--next" (click)="nextMyth()">›</button>
          </div>
        </div>
      </section>

      <section class="section section--cta">
        <div class="section__inner">
          <div class="cta-board">
            <div class="cta-board__header-row">
              <div class="section__topic">
                <h2>每個人的健康都不同，找到<span>屬於您</span>的檢查</h2>
                <p>立即預約，開始您的專屬健檢方案</p>
              </div>
            </div>

            <div class="cta-board__content">
              <div class="cta-board__enterprise">
                <div class="action-board__header">
                  <div class="action-board__icon">
                    <span class="icon">
                      <img src="assets/img/icon-building.svg" alt="icon" class="icon-img" />
                    </span>
                  </div>
                  <span class="action-board__label">企業員工．眷屬的健檢方案</span>
                </div>

                <div class="action-board__input-row">
                  <input type="text" placeholder="請輸入企業代碼" [class.input-error]="hasError"
                    [formControl]="enterpriseCodeControl" (keydown.enter)="handleEnterpriseClick()" maxlength="10"
                    (input)="onInputChange($event)" />
                  <button class="btn btn--primary btn--sm" [disabled]="isButtonDisabled"
                    (click)="handleEnterpriseClick()">開始預約</button>
                </div>
              </div>

              <div class="cta-board__divider"></div>

              <div class="cta-board__personal">
                <div class="action-board__header">
                  <div class="action-board__icon">
                    <span class="icon">
                      <img src="assets/img/icon-family-users.svg" alt="icon" class="icon-img" />
                    </span>
                  </div>
                  <span class="action-board__label">個人專屬的健檢方案</span>
                </div>

                <div class="action-board__personal-btns">
                  <button class="btn btn--green-tint" (click)="handlePersonalClick()">
                    曾經來過，直接預約 <span>→</span>
                  </button>
                  <button class="btn btn--green-tint" (click)="handleQuickReserveClick()">
                    第一次來，了解方案 <span>→</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- ===== FOOTER ===== -->
      <footer class="footer">
        <div class="footer__main">
          <div class="footer__locations">
            @for (loc of locations; track loc.name) {
            <div class="footer__address">
              <strong>{{ loc.name }}</strong>
              <span>{{ loc.address }}</span>
              <span>{{ loc.address1 }}</span>
              <span>{{ loc.address2 }}</span>
            </div>
            }
          </div>

          <button class="footer__back-top" (click)="scrollToTop()">
            <span class="footer__back-top-arrow">↑</span>
            <span>Page Top</span>
          </button>
        </div>

        <div class="footer__copyright">
          © 2026 國泰健康管理 All rights reserved.<br />
          平台服務提供商：國泰健康管理顧問股份有限公司
        </div>
      </footer>
    </div>
  </section>
</div>
} @else {
<h3 class="home-en-block">
  For English assistance, please call our dedicated hotline: 02-412-8006.
</h3>
<p class="version-text">V3.1.7</p>
}
}